import React from 'react';
import PropTypes from 'prop-types';
import renderIf from '@signal/utils/renderIf';
import { Wrapper, Title, Content, SubTitle, SubTitleWrapper } from './styles';
export function Panel(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      children = _ref.children,
      style = _ref.style,
      className = _ref.className,
      contentStyle = _ref.contentStyle,
      titleStyle = _ref.titleStyle;
  return /*#__PURE__*/React.createElement(Wrapper, {
    style: style,
    className: className
  }, renderIf(title || subtitle, function () {
    return /*#__PURE__*/React.createElement(Title, {
      style: titleStyle
    }, renderIf(title, function () {
      return title;
    }), renderIf(subtitle, function () {
      return /*#__PURE__*/React.createElement(SubTitleWrapper, null, /*#__PURE__*/React.createElement(SubTitle, null, subtitle));
    }));
  }), /*#__PURE__*/React.createElement(Content, {
    style: contentStyle
  }, children));
}
Panel.propTypes = {
  title: PropTypes.node,
  titleStyle: PropTypes.object,
  contentStyle: PropTypes.object
};
Panel.defaultProps = {
  titleStyle: {},
  contentStyle: {}
};
export default Panel;